/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2021-02-19 11:27:43
 */
import SetPage from './setPage/setPage'
// import P1 from './p1/p1'
import P2 from './p2/p2'
// import P3 from './p3/p3'
// import P4 from './p4/p4'
import P5 from './p5/p5'
import P6 from './p6/p6'
import P7 from './p7/p7'
import P8 from './p8/p8'
import P9 from './p9/p9'
// import P10 from './p10/p10'
// import P11 from './p11/p11'
import P12 from './p12/p12'
import P22 from './p22/p22'
import P23 from './p23/p23'
import P24 from './p24/p24'
import P25 from './p25/p25'
import P26 from './p26/p26'
import P27 from './p27/p27'
import P30 from './p30/p30'
import pageNull from './pageNull'

export default {
  SetPage,
  // P1,
  P2,
  // P3,
  // P4,
  P5,
  P6,
  P7,
  P8,
  P9,
  // P10,
  // P11,
  P12,
  P22,
  P23,
  P24,
  P25,
  P26,
  P27,
  P30,
  pageNull
}


// WEBPACK FOOTER //
// src/routes/exportPDF/router.js